import React, { useState, useMemo } from 'react'
import { updateTicket, deleteTicket, fetchTickets, updateCandidate, fetchAgents, fetchCandidates, fetchCandidateById } from '../lib/api'
import SpecialBadge from './SpecialBadge'

function AgentsAnalytics({ agents }) {
  const [openAgents, setOpenAgents] = React.useState(new Set())
  const [openCats, setOpenCats] = React.useState(new Set())
  const [dateFrom, setDateFrom] = React.useState('')
  const [dateTo, setDateTo] = React.useState('')

  const inp = { fontSize: 13, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white' }

  function inRange(date) {
    if (!date) return true
    if (dateFrom && date < dateFrom) return false
    if (dateTo && date > dateTo) return false
    return true
  }

  const allAgentExp = agents.flatMap(a =>
    (a.expenses || []).map(e => ({ ...e, agentName: a.name, agentId: a.id }))
  ).filter(e => inRange(e.date))
  const totalAll = allAgentExp.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0)

  const byAgent = agents
    .map(a => {
      const items = (a.expenses || []).filter(e => inRange(e.date))
      return {
        id: a.id, name: a.name,
        total: items.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0),
        items,
      }
    })
    .filter(a => a.total > 0)
    .sort((a, b) => b.total - a.total)

  const byCategory = allAgentExp.reduce((acc, e) => {
    const cat = e.category || 'Прочее'
    if (!acc[cat]) acc[cat] = { sum: 0, items: [] }
    acc[cat].sum += parseFloat(e.amount) || 0
    acc[cat].items.push(e)
    return acc
  }, {})

  const maxAgent = byAgent[0]?.total || 1

  function fmt(d) { return d ? d.split('-').reverse().join('.') : '—' }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: '#888' }}>Период:</span>
        <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} style={inp} />
        <span style={{ fontSize: 12, color: '#888' }}>—</span>
        <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} style={inp} />
        {(dateFrom || dateTo) && <button onClick={() => { setDateFrom(''); setDateTo('') }} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>✕ Сбросить</button>}
      </div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600 }}>{agents.length}</div>
          <div style={{ fontSize: 11, color: '#888' }}>Агентов</div>
        </div>
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#378ADD' }}>{totalAll.toLocaleString('ru-RU')} ₽</div>
          <div style={{ fontSize: 11, color: '#888' }}>Потрачено на агентов</div>
        </div>
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600 }}>{allAgentExp.length}</div>
          <div style={{ fontSize: 11, color: '#888' }}>Транзакций</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20, alignItems: 'start' }}>
        {/* По агентам */}
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 20px', maxHeight: 500, overflowY: 'auto' }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>Расходы по агентам</div>
          {byAgent.length === 0 && <div style={{ fontSize: 12, color: '#bbb', textAlign: 'center', padding: 20 }}>Нет данных</div>}
          {byAgent.map((a, i) => {
            const isOpen = openAgents.has(a.id)
            return (
              <div key={a.id} style={{ marginBottom: 10, borderBottom: '0.5px solid #f5f5f3', paddingBottom: 8 }}>
                <div onClick={() => setOpenAgents(prev => { const n = new Set(prev); isOpen ? n.delete(a.id) : n.add(a.id); return n })} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4, cursor: 'pointer', userSelect: 'none' }}>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: 10, color: '#bbb', width: 10 }}>{isOpen ? '▼' : '▶'}</span>
                    <span style={{ fontWeight: 500 }}>{a.name}</span>
                    <span style={{ color: '#bbb', fontSize: 11 }}>({a.items.length})</span>
                  </div>
                  <span style={{ fontWeight: 600 }}>{a.total.toLocaleString('ru-RU')} ₽</span>
                </div>
                <div style={{ height: 5, background: '#f5f5f3', borderRadius: 3, overflow: 'hidden', marginLeft: 16 }}>
                  <div style={{ height: '100%', background: '#378ADD', borderRadius: 3, width: (a.total / maxAgent * 100) + '%' }} />
                </div>
                {isOpen && (
                  <div style={{ marginTop: 6, marginLeft: 16 }}>
                    {a.items.sort((x, y) => (y.date || '') > (x.date || '') ? 1 : -1).map((e, j) => (
                      <div key={j} style={{ display: 'flex', gap: 8, padding: '4px 8px', background: '#fafaf8', borderRadius: 6, marginBottom: 2, fontSize: 11, alignItems: 'center' }}>
                        <span style={{ color: '#bbb', minWidth: 65 }}>{fmt(e.date)}</span>
                        <span style={{ background: '#f0f0ec', padding: '1px 6px', borderRadius: 4, color: '#555', flexShrink: 0 }}>{e.category}</span>
                        {e.comment && <span style={{ color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.comment}</span>}
                        {e.file && <a href={e.file.url} target="_blank" rel="noreferrer" style={{ color: '#378ADD', fontSize: 11, flexShrink: 0 }}>📎</a>}
                        <span style={{ fontWeight: 600, marginLeft: 'auto', whiteSpace: 'nowrap' }}>{parseFloat(e.amount).toLocaleString('ru-RU')} ₽</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
        </div>

        {/* По категориям */}
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 20px', maxHeight: 500, overflowY: 'auto' }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>По категориям</div>
          {Object.keys(byCategory).length === 0 && <div style={{ fontSize: 12, color: '#bbb', textAlign: 'center', padding: 20 }}>Нет данных</div>}
          {Object.entries(byCategory).sort((a, b) => b[1].sum - a[1].sum).map(([cat, { sum, items }]) => {
            const isOpen = openCats.has(cat)
            return (
              <div key={cat} style={{ borderBottom: '0.5px solid #f5f5f3' }}>
                <div onClick={() => setOpenCats(prev => { const n = new Set(prev); isOpen ? n.delete(cat) : n.add(cat); return n })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 0', cursor: 'pointer', fontSize: 13, userSelect: 'none' }}>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: 10, color: '#bbb', width: 10 }}>{isOpen ? '▼' : '▶'}</span>
                    <span style={{ color: '#444' }}>{cat}</span>
                    <span style={{ fontSize: 11, color: '#bbb' }}>({items.length})</span>
                  </div>
                  <span style={{ fontWeight: 600, color: '#378ADD' }}>{sum.toLocaleString('ru-RU')} ₽</span>
                </div>
                {isOpen && (
                  <div style={{ paddingBottom: 8 }}>
                    {items.sort((a, b) => (b.date || '') > (a.date || '') ? 1 : -1).map((e, j) => (
                      <div key={j} style={{ display: 'flex', gap: 8, padding: '4px 8px', background: '#fafaf8', borderRadius: 6, marginBottom: 2, fontSize: 11, alignItems: 'center' }}>
                        <span style={{ color: '#bbb', minWidth: 65 }}>{fmt(e.date)}</span>
                        <span style={{ fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.agentName}</span>
                        {e.comment && <span style={{ color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.comment}</span>}
                        <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{parseFloat(e.amount).toLocaleString('ru-RU')} ₽</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
          {Object.keys(byCategory).length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 13, fontWeight: 600 }}>
              <span>Итого</span>
              <span style={{ color: '#378ADD' }}>{totalAll.toLocaleString('ru-RU')} ₽</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

function fmtDateStr(s) {
  if (!s) return '—'
  const d = String(s).slice(0, 10) // берём только YYYY-MM-DD
  return d.split('-').reverse().join('.')
}

function TicketsRegistry({ tickets, candidates, loading, statusFilter, setStatusFilter, onUpdateTicket, onDeleteTicket }) {
  const [editingId, setEditingId] = useState(null)
  const [editVals, setEditVals] = useState({})
  const [search, setSearch] = useState(() => localStorage.getItem('ticket_search') || '')
  const [onlyReturn, setOnlyReturn] = useState(false)

  function handleSearch(v) { setSearch(v); localStorage.setItem('ticket_search', v) }

  function startEdit(t) {
    setEditingId(t.id)
    setEditVals({ ticket_number: t.ticket_number || '', price: t.price || '', refund_status: t.refund_status || '', refund_amount: t.refund_amount || '', refund_submitted_date: t.refund_submitted_date || '', refund_actual_amount: t.refund_actual_amount || '', refund_actual_date: t.refund_actual_date || '' })
  }

  async function saveEdit(id) {
    await onUpdateTicket(id, {
      ticket_number: editVals.ticket_number,
      price: editVals.price || 0,
      refund_status: editVals.refund_status,
      refund_amount: editVals.refund_amount || null,
      refund_submitted_date: editVals.refund_submitted_date || null,
      refund_actual_amount: editVals.refund_actual_amount ? parseFloat(editVals.refund_actual_amount) : null,
      refund_actual_date: editVals.refund_actual_date || null,
    })
    setEditingId(null)
  }
  const filtered = tickets.filter(t => {
    if (t.type === 'автобус') return false
    if (onlyReturn && t.type !== 'обратный') return false
    if (statusFilter === 'none' && t.refund_status) return false
    if (statusFilter && statusFilter !== 'none' && t.refund_status !== statusFilter) return false
    if (search) {
      const q = search.toLowerCase()
      const c = candidates.find(c => c.id === t.candidate_id)
      const matchesTicket = t.ticket_number?.toLowerCase().includes(q)
      const matchesCandidate = c && (c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q))
      if (!matchesTicket && !matchesCandidate) return false
    }
    return true
  })

  const totalSpent = filtered.reduce((sum, t) => sum + (parseFloat(t.price) || 0), 0)
  const totalRefund = filtered.filter(t => t.refund_status === 'Возврат').reduce((sum, t) => sum + (parseFloat(t.refund_amount) || 0), 0)
  const totalActualRefund = filtered.reduce((sum, t) => sum + (parseFloat(t.refund_actual_amount) || 0), 0)

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600 }}>{filtered.length}</div>
          <div style={{ fontSize: 11, color: '#888' }}>Билетов</div>
        </div>
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600 }}>{totalSpent.toLocaleString('ru-RU')} ₽</div>
          <div style={{ fontSize: 11, color: '#888' }}>Потрачено всего</div>
        </div>
        <div style={{ background: '#FCEBEB', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#E24B4A' }}>{filtered.filter(t => t.refund_status === 'Возврат').length}</div>
          <div style={{ fontSize: 11, color: '#E24B4A' }}>На возврате</div>
        </div>
        <div style={{ background: '#FFF8E7', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#7A5800' }}>{totalRefund.toLocaleString('ru-RU')} ₽</div>
          <div style={{ fontSize: 11, color: '#7A5800' }}>Расч. к возврату</div>
        </div>
        <div style={{ background: '#EAF3DE', border: '1px solid #e8e8e5', borderRadius: 10, padding: '12px 16px', flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 600, color: '#27500A' }}>{totalActualRefund.toLocaleString('ru-RU')} ₽</div>
          <div style={{ fontSize: 11, color: '#27500A' }}>Получено фактически</div>
        </div>
      </div>

      <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '12px 16px', marginBottom: 16, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <input value={search} onChange={e => handleSearch(e.target.value)} placeholder="🔍 Поиск по имени, паспорту или номеру билета" style={{ fontSize: 13, padding: '6px 12px', borderRadius: 8, border: '1px solid #e0e0dc', flex: 1, minWidth: 200 }} />
        <span style={{ fontSize: 12, color: '#888' }}>Статус:</span>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
          <option value="">Все</option>
          <option value="Успех">Успех</option>
          <option value="Возврат">Возврат</option>
          <option value="none">Без статуса (не забыли заполнить?)</option>
        </select>
        <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, color: '#444', cursor: 'pointer', marginLeft: 8 }}>
          <input type="checkbox" checked={onlyReturn} onChange={e => setOnlyReturn(e.target.checked)} />
          Только обратные
        </label>
      </div>

      <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0ec', fontSize: 14, fontWeight: 600 }}>
          Реестр билетов <span style={{ fontWeight: 400, color: '#888', fontSize: 12 }}>({filtered.length} записей)</span>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#fafaf8' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Дата покупки</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Кто купил</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Направление</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Кандидат</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Авиакомпания</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Агрегатор</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Номер брони</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Вылет</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Прилёт</th>
                <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Стоимость</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Статус</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Дата подачи</th>
                <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Расч. сумма</th>
                <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Реальная сумма</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Дата возврата</th>
                <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={15} style={{ padding: 24, textAlign: 'center', color: '#bbb' }}>Загрузка...</td></tr>}
              {!loading && filtered.length === 0 && <tr><td colSpan={15} style={{ padding: 24, textAlign: 'center', color: '#bbb' }}>Нет данных</td></tr>}
              {filtered.map((t, i) => {
                const isEditing = editingId === t.id
                return (
                <tr key={i} style={{ borderBottom: '0.5px solid #f5f5f3' }}>
                  <td style={{ padding: '10px 12px', color: '#666' }}>{fmtDateStr(t.purchase_date || t.created_at)}</td>
                  <td style={{ padding: '10px 12px', color: '#666' }}>{t.purchased_by || '—'}</td>
                  <td style={{ padding: '10px 12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      <span>{t.from_city} → {t.to_city}</span>
                      {t.type === 'обратный' && (
                        <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 7px', borderRadius: 10, background: '#dbeafe', color: '#1d4ed8', whiteSpace: 'nowrap' }}>обратный</span>
                      )}
                    </div>
                  </td>
                  <td style={{ padding: '10px 12px' }}>
                    {(() => {
                      const cand = candidates.find(c => c.id === t.candidate_id)
                      if (!cand) return '—'
                      return (
                        <div>
                          <div style={{ fontWeight: 500, color: '#1a1a1a' }}>{cand.name}</div>
                          <div style={{ color: '#888', fontSize: 11, textAlign: 'center' }}>{cand.passport}</div>
                        </div>
                      )
                    })()}
                  </td>
                  <td style={{ padding: '10px 12px', color: '#666' }}>{t.airline || '—'}</td>
                  <td style={{ padding: '10px 12px', color: '#666' }}>{t.aggregator || '—'}</td>
                  <td style={{ padding: '10px 12px' }}>
                    {isEditing ? <input value={editVals.ticket_number} onChange={e => setEditVals(v => ({ ...v, ticket_number: e.target.value }))} style={{ width: 90, fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc' }} /> : (t.ticket_number || '—')}
                  </td>
                  <td style={{ padding: '10px 12px', color: '#666', fontSize: 11 }}>{t.departure_date ? fmtDateStr(t.departure_date) + (t.departure_time ? ' ' + t.departure_time.slice(0,5) : '') : '—'}</td>
                  <td style={{ padding: '10px 12px', color: '#666', fontSize: 11 }}>{t.arrival_date ? fmtDateStr(t.arrival_date) + (t.arrival_time ? ' ' + t.arrival_time.slice(0,5) : '') : '—'}</td>
                  <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>
                    {isEditing ? <input type="text" inputMode="numeric" value={editVals.price} onChange={e => setEditVals(v => ({ ...v, price: e.target.value.replace(/[^0-9.]/g, '') }))} style={{ width: 80, fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc', textAlign: 'right' }} /> : (parseFloat(t.price || 0).toLocaleString('ru-RU') + ' ₽')}
                  </td>
                  <td style={{ padding: '10px 12px' }}>
                    {isEditing ? (
                      <select value={editVals.refund_status} onChange={e => setEditVals(v => ({ ...v, refund_status: e.target.value }))} style={{ fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc' }}>
                        <option value="">В процессе</option>
                        <option value="Успех">Успех</option>
                        <option value="Возврат">Возврат</option>
                      </select>
                    ) : (
                      <span style={{ padding: '2px 8px', borderRadius: 6, fontSize: 11, background: t.refund_status === 'Возврат' ? '#FCEBEB' : t.refund_status === 'Успех' ? '#EAF3DE' : '#FAEEDA', color: t.refund_status === 'Возврат' ? '#E24B4A' : t.refund_status === 'Успех' ? '#27500A' : '#633806' }}>
                        {t.refund_status || 'В процессе'}
                      </span>
                    )}
                  </td>
                  <td style={{ padding: '10px 12px', color: '#666', fontSize: 11 }}>
                    {isEditing ? <input type="date" value={editVals.refund_submitted_date} onChange={e => setEditVals(v => ({ ...v, refund_submitted_date: e.target.value }))} style={{ fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc' }} /> : fmtDateStr(t.refund_submitted_date)}
                  </td>
                  <td style={{ padding: '10px 12px', textAlign: 'right', color: '#888' }}>
                    {isEditing ? <input type="text" inputMode="numeric" value={editVals.refund_amount} onChange={e => setEditVals(v => ({ ...v, refund_amount: e.target.value.replace(/[^0-9.]/g, '') }))} style={{ width: 80, fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc', textAlign: 'right' }} /> : (t.refund_amount ? parseFloat(t.refund_amount).toLocaleString('ru-RU') + ' ₽' : '—')}
                  </td>
                  <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: t.refund_actual_amount ? 600 : 400, color: t.refund_actual_amount ? '#27500A' : '#bbb' }}>
                    {isEditing ? <input type="text" inputMode="numeric" value={editVals.refund_actual_amount} onChange={e => setEditVals(v => ({ ...v, refund_actual_amount: e.target.value.replace(/[^0-9.]/g, '') }))} style={{ width: 80, fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc', textAlign: 'right' }} /> : (t.refund_actual_amount ? parseFloat(t.refund_actual_amount).toLocaleString('ru-RU') + ' ₽' : '—')}
                  </td>
                  <td style={{ padding: '10px 12px', color: '#666', fontSize: 11 }}>
                    {isEditing ? <input type="date" value={editVals.refund_actual_date} onChange={e => setEditVals(v => ({ ...v, refund_actual_date: e.target.value }))} style={{ fontSize: 12, padding: '4px 6px', borderRadius: 6, border: '1px solid #e0e0dc' }} /> : fmtDateStr(t.refund_actual_date)}
                  </td>
                  <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                    {isEditing ? (
                      <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                        <button onClick={() => saveEdit(t.id)} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: 'none', background: '#639922', color: 'white', cursor: 'pointer' }}>✓</button>
                        <button onClick={() => setEditingId(null)} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                        <button onClick={() => startEdit(t)} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>✏</button>
                        <button onClick={() => { if (window.confirm('Удалить билет из реестра? Запись также будет удалена из маршрута кандидата.')) onDeleteTicket(t) }} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: '1px solid #fca5a5', background: 'white', cursor: 'pointer', color: '#E24B4A' }}>✕</button>
                      </div>
                    )}
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
export default function AnalyticsPage({ candidates: candidatesProp, locations, onClose, isAdmin, workspace = 'main' }) {
  const [candidates, setCandidates] = useState(candidatesProp)
  const [expandedCategories, setExpandedCategories] = useState(new Set())
  const [expandedCandidates, setExpandedCandidates] = useState(new Set())
  const [filterOperator, setFilterOperator] = useState('')
  const [filterCategory, setFilterCategory] = useState('')
  const [filterLocation, setFilterLocation] = useState('')
  const [filterArchive, setFilterArchive] = useState('active')
  const [expenseSearch, setExpenseSearch] = useState('')
  const [filterPeriod, setFilterPeriod] = useState('all')
  const [filterDateFrom, setFilterDateFrom] = useState('')
  const [filterDateTo, setFilterDateTo] = useState('')
  const [activeTab, setActiveTabRaw] = useState(() => localStorage.getItem('analytics_tab') || 'expenses')
  function setActiveTab(v) { setActiveTabRaw(v); localStorage.setItem('analytics_tab', v) }
  const [tickets, setTickets] = useState([])
  const [ticketsLoading, setTicketsLoading] = useState(true)
  const [ticketStatusFilter, setTicketStatusFilter] = useState('')
  const [agents, setAgents] = useState([])

  React.useEffect(() => {
    fetchTickets().then(data => { setTickets(data); setTicketsLoading(false) }).catch(() => setTicketsLoading(false))
    fetchAgents().then(setAgents).catch(() => {})
    fetchCandidates(workspace).then(setCandidates).catch(() => {})
  }, [])

  // Собираем все расходы из всех кандидатов
  const allExpenses = useMemo(() => {
    const result = []
    candidates.forEach(c => {
      if (!c.expenses || c.expenses.length === 0) return
      c.expenses.forEach(exp => {
        result.push({
          candidateName: c.name,
          candidateId: c.id,
          passport: c.passport,
          responsible: c.responsible_name || '—',
          location: exp.location_name || locations.find(l => l.id === c.location_id)?.name || '—',
          category: exp.category || '—',
          amount: parseFloat(exp.amount) || 0,
          comment: exp.comment || '',
          operator_id: exp.operator_id || '',
          date: exp.date || exp.created_at || null,
          archived: !!c.archived,
          candidateStatus: c.status || '',
        })
      })
    })
    return result
  }, [candidates, locations])

  // Уникальные операторы и категории
  const operators = [...new Set(candidates.map(c => c.responsible_name).filter(Boolean))]
  const categories = [...new Set(allExpenses.map(e => e.category).filter(c => c !== '—'))]

  // Фильтрация
const filtered = allExpenses.filter(e => {
    if (filterArchive === 'active' && (e.archived || e.candidateStatus === 'завершен')) return false
    if (filterArchive === 'archived' && !e.archived) return false
    if (filterArchive === 'completed' && (e.archived || e.candidateStatus !== 'завершен')) return false
    if (filterOperator && e.responsible !== filterOperator) return false
    if (filterCategory && e.category !== filterCategory) return false
    if (filterLocation && e.location !== filterLocation) return false
    if (filterPeriod === 'range') {
      if (!e.date) return false
      const expDate = e.date.split('T')[0]
      if (filterDateFrom && expDate < filterDateFrom) return false
      if (filterDateTo && expDate > filterDateTo) return false
    }
    if (expenseSearch) {
      const q = expenseSearch.toLowerCase()
      if (!e.candidateName?.toLowerCase().includes(q) && !e.passport?.toLowerCase().includes(q)) return false
    }
    return true
  })

  const totalSum = filtered.reduce((sum, e) => sum + e.amount, 0)

  // По кандидатам
  const byCandidates = useMemo(() => {
    const map = {}
    filtered.forEach(e => {
      if (!map[e.candidateId]) map[e.candidateId] = { id: e.candidateId, name: e.candidateName, passport: e.passport, responsible: e.responsible, location: e.location, total: 0, items: [] }
      map[e.candidateId].total += e.amount
      map[e.candidateId].items.push(e)
    })
    return Object.values(map).sort((a, b) => b.total - a.total)
  }, [filtered])

  // По категориям
  const byCategory = useMemo(() => {
    const map = {}
    filtered.forEach(e => {
      if (!map[e.category]) map[e.category] = { sum: 0, items: [] }
      map[e.category].sum += e.amount
      map[e.category].items.push(e)
    })
    return Object.entries(map).sort((a, b) => b[1].sum - a[1].sum)
  }, [filtered])

  const maxAmount = byCandidates.length > 0 ? byCandidates[0].total : 1

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f3' }}>
      <header style={{ background: 'white', borderBottom: '1px solid #e8e8e5', padding: '0 24px', position: 'sticky', top: 0, zIndex: 100 }}>
       <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', height: 60, gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={onClose} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 20, color: '#888', padding: '4px 8px' }}>←</button>
            <h1 style={{ fontSize: 17, fontWeight: 600 }}>📊 Аналитика</h1><SpecialBadge />
          </div>
          <div style={{ display: 'flex', background: '#f5f5f3', borderRadius: 8, padding: 3, gap: 3 }}>
            <button onClick={() => setActiveTab('expenses')} style={{ fontSize: 12, padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', background: activeTab === 'expenses' ? 'white' : 'transparent', fontWeight: activeTab === 'expenses' ? 600 : 400, color: activeTab === 'expenses' ? '#1a1a1a' : '#888', boxShadow: activeTab === 'expenses' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none' }}>Расходы</button>
            <button onClick={() => setActiveTab('tickets')} style={{ fontSize: 12, padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', background: activeTab === 'tickets' ? 'white' : 'transparent', fontWeight: activeTab === 'tickets' ? 600 : 400, color: activeTab === 'tickets' ? '#1a1a1a' : '#888', boxShadow: activeTab === 'tickets' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none' }}>✈ Реестр билетов</button>
            <button onClick={() => setActiveTab('agents')} style={{ fontSize: 12, padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', background: activeTab === 'agents' ? 'white' : 'transparent', fontWeight: activeTab === 'agents' ? 600 : 400, color: activeTab === 'agents' ? '#1a1a1a' : '#888', boxShadow: activeTab === 'agents' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none' }}>🤝 Агенты</button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {activeTab === 'expenses' && <div style={{ fontSize: 15, fontWeight: 600, color: '#639922' }}>Итого: {totalSum.toLocaleString('ru-RU')} ₽</div>}
          </div>
        </div>
      </header>

      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
{activeTab === 'agents' && (
          <AgentsAnalytics agents={agents} />
        )}
{activeTab === 'tickets' && (
          <TicketsRegistry tickets={tickets} candidates={candidates} loading={ticketsLoading} statusFilter={ticketStatusFilter} setStatusFilter={setTicketStatusFilter} onDeleteTicket={async (t) => {
            await deleteTicket(t.id)
            setTickets(prev => prev.filter(tk => tk.id !== t.id))
            if (t.candidate_id) {
              const freshC = await fetchCandidateById(t.candidate_id)
              if (freshC && Array.isArray(freshC.route)) {
                const updatedRoute = freshC.route.map(p => p.ticket_id === t.id ? { ...p, ticket_id: null } : p)
                await updateCandidate(t.candidate_id, { route: updatedRoute })
                setCandidates(prev => prev.map(c => c.id === t.candidate_id ? { ...c, route: updatedRoute } : c))
              }
            }
          }} onUpdateTicket={async (id, updates) => {
            await updateTicket(id, updates)
            setTickets(prev => prev.map(t => t.id === id ? { ...t, ...updates } : t))
            if ('refund_actual_amount' in updates) {
              const ticket = tickets.find(t => t.id === id)
              if (ticket?.candidate_id) {
                const fresh = await fetchCandidateById(ticket.candidate_id)
                if (fresh) {
                  const expenses = Array.isArray(fresh.expenses) ? [...fresh.expenses] : []
                  const withoutRefund = expenses.filter(e => e.ticket_refund_id !== id)
                  const actual = parseFloat(updates.refund_actual_amount)
                  if (actual > 0) {
                    withoutRefund.push({
                      category: 'Возврат билета',
                      amount: -actual,
                      ticket_refund_id: id,
                      comment: `Возврат за билет ${ticket.from_city || ''}→${ticket.to_city || ''}`,
                      date: new Date().toISOString(),
                    })
                  }
                  await updateCandidate(ticket.candidate_id, { expenses: withoutRefund })
                  setCandidates(prev => prev.map(c => c.id === ticket.candidate_id ? { ...c, expenses: withoutRefund } : c))
                }
              }
            }
          }} />
        )}
        {activeTab === 'expenses' && <>

        {/* Фильтры */}
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 20px', marginBottom: 20, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
  <div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>Период</div>
            <select value={filterPeriod} onChange={e => setFilterPeriod(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
              <option value="all">Всё время</option>
              <option value="range">Диапазон дат</option>
            </select>
          </div>
          {filterPeriod === 'range' && <>
            <div>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>С</div>
              <input type="date" value={filterDateFrom} onChange={e => setFilterDateFrom(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>По</div>
              <input type="date" value={filterDateTo} onChange={e => setFilterDateTo(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }} />
            </div>
          </>}
          <div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>Кандидаты</div>
            <select value={filterArchive} onChange={e => setFilterArchive(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
              <option value="active">Действующие</option>
              <option value="completed">Завершённые</option>
              <option value="archived">Архивные</option>
              <option value="all">Все</option>
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>Ответственный</div>
            <select value={filterOperator} onChange={e => setFilterOperator(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
              <option value="">Все</option>
              {operators.map(o => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>Категория</div>
            <select value={filterCategory} onChange={e => setFilterCategory(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
              <option value="">Все</option>
              {categories.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>Локация</div>
            <select value={filterLocation} onChange={e => setFilterLocation(e.target.value)} style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
              <option value="">Все</option>
              {locations.map(l => <option key={l.id} value={l.name}>{l.name}</option>)}
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', marginBottom: 4, fontWeight: 500 }}>Кандидат</div>
            <input value={expenseSearch} onChange={e => setExpenseSearch(e.target.value)} placeholder="Имя или паспорт..." style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', minWidth: 180 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <button onClick={() => { setFilterOperator(''); setFilterCategory(''); setFilterLocation(''); setFilterArchive('active'); setFilterPeriod('all'); setFilterDateFrom(''); setFilterDateTo(''); setExpenseSearch('') }} style={{ fontSize: 12, padding: '6px 12px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'transparent', cursor: 'pointer', color: '#888' }}>Сбросить</button>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20, alignItems: 'start' }}>
          {/* Топ по кандидатам */}
          <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 20px', maxHeight: 480, overflowY: 'auto' }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>Расходы по кандидатам</div>
            {byCandidates.length === 0 && <div style={{ fontSize: 12, color: '#bbb', textAlign: 'center', padding: 20 }}>Нет данных</div>}
            {byCandidates.map((c, i) => {
              const isOpen = expandedCandidates.has(c.id)
              return (
                <div key={i} style={{ marginBottom: 8, borderBottom: '0.5px solid #f5f5f3', paddingBottom: 8 }}>
                  <div
                    onClick={() => setExpandedCandidates(prev => { const next = new Set(prev); isOpen ? next.delete(c.id) : next.add(c.id); return next })}
                    style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4, cursor: 'pointer', userSelect: 'none' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 10, color: '#bbb', width: 10 }}>{isOpen ? '▼' : '▶'}</span>
                      <div>
                        <span style={{ fontWeight: 500 }}>{c.name}</span>
                        <span style={{ color: '#bbb', marginLeft: 6 }}>{c.passport}</span>
                      </div>
                    </div>
                    <span style={{ fontWeight: 600, color: '#1a1a1a' }}>{c.total.toLocaleString('ru-RU')} ₽</span>
                  </div>
                  <div style={{ height: 6, background: '#f5f5f3', borderRadius: 3, overflow: 'hidden', marginLeft: 16 }}>
                    <div style={{ height: '100%', background: '#639922', borderRadius: 3, width: (c.total / maxAmount * 100) + '%', transition: 'width .3s' }} />
                  </div>
                  <div style={{ fontSize: 10, color: '#bbb', marginTop: 2, marginLeft: 16 }}>{c.responsible} · {c.location}</div>
                  {isOpen && (
                    <div style={{ marginTop: 8, marginLeft: 16 }}>
                      {c.items.sort((a, b) => (b.date || '') > (a.date || '') ? 1 : -1).map((e, j) => (
                        <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 8px', borderRadius: 6, background: '#fafaf8', marginBottom: 3, fontSize: 11 }}>
                          <span style={{ color: '#bbb', whiteSpace: 'nowrap', minWidth: 65 }}>
                            {e.date ? e.date.split('T')[0].split('-').reverse().join('.') : '—'}
                          </span>
                          <span style={{ background: '#f0f0ec', padding: '1px 6px', borderRadius: 4, color: '#555', whiteSpace: 'nowrap' }}>{e.category}</span>
                          {e.comment && <span style={{ color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.comment}</span>}
                          <span style={{ fontWeight: 600, color: e.amount < 0 ? '#27500A' : '#1a1a1a', whiteSpace: 'nowrap', marginLeft: 'auto' }}>{e.amount.toLocaleString('ru-RU')} ₽</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}
          </div>

          {/* По категориям */}
          <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 20px', maxHeight: 480, overflowY: 'auto' }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>Расходы по категориям</div>
            {byCategory.length === 0 && <div style={{ fontSize: 12, color: '#bbb', textAlign: 'center', padding: 20 }}>Нет данных</div>}
            {byCategory.map(([cat, { sum, items }], i) => {
              const isOpen = expandedCategories.has(cat)
              return (
                <div key={i} style={{ borderBottom: '0.5px solid #f5f5f3' }}>
                  <div
                    onClick={() => setExpandedCategories(prev => { const next = new Set(prev); isOpen ? next.delete(cat) : next.add(cat); return next })}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', fontSize: 13, cursor: 'pointer', userSelect: 'none' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 10, color: '#bbb', width: 10 }}>{isOpen ? '▼' : '▶'}</span>
                      <span style={{ color: '#444' }}>{cat}</span>
                      <span style={{ fontSize: 11, color: '#bbb' }}>({items.length})</span>
                    </div>
                    <span style={{ fontWeight: 600, color: '#378ADD' }}>{sum.toLocaleString('ru-RU')} ₽</span>
                  </div>
                  {isOpen && (
                    <div style={{ paddingBottom: 8 }}>
                      {items.sort((a, b) => (b.date || '') > (a.date || '') ? 1 : -1).map((e, j) => (
                        <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 8px', borderRadius: 6, background: '#fafaf8', marginBottom: 3, fontSize: 12 }}>
                          <span style={{ color: '#bbb', fontSize: 11, whiteSpace: 'nowrap', minWidth: 70 }}>
                            {e.date ? e.date.split('T')[0].split('-').reverse().join('.') : '—'}
                          </span>
                          <span style={{ fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.candidateName}</span>
                          {e.comment && <span style={{ color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.comment}</span>}
                          <span style={{ fontWeight: 600, color: e.amount < 0 ? '#27500A' : '#1a1a1a', whiteSpace: 'nowrap' }}>{e.amount.toLocaleString('ru-RU')} ₽</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}
            {byCategory.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 13, fontWeight: 600 }}>
                <span>Итого</span>
                <span style={{ color: '#639922' }}>{totalSum.toLocaleString('ru-RU')} ₽</span>
              </div>
            )}
          </div>
        </div>

        {/* Полная таблица */}
        <div style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0ec', fontSize: 14, fontWeight: 600 }}>
            Все расходы <span style={{ fontWeight: 400, color: '#888', fontSize: 12 }}>({filtered.length} записей)</span>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#fafaf8' }}>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Дата</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Кандидат</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Локация</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Категория</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Комментарий</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Ответственный</th>
                  <th style={{ padding: '10px 16px', textAlign: 'right', fontWeight: 600, color: '#888', borderBottom: '1px solid #f0f0ec' }}>Сумма</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 && (
                  <tr><td colSpan={7} style={{ padding: 24, textAlign: 'center', color: '#bbb' }}>Нет данных</td></tr>
                )}
                {[...filtered].sort((a, b) => {
  if (!a.date && !b.date) return 0
  if (!a.date) return 1
  if (!b.date) return -1
  return b.date > a.date ? 1 : -1
}).map((e, i) => (
                  <tr key={i} style={{ borderBottom: '0.5px solid #f5f5f3' }}
                    onMouseOver={ev => ev.currentTarget.style.background = '#fafaf8'}
                    onMouseOut={ev => ev.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 16px', color: '#666', whiteSpace: 'nowrap' }}>
                      {e.date ? e.date.split('T')[0].split('-').reverse().join('.') : '—'}
                    </td>
                    <td style={{ padding: '10px 16px' }}>
                      <div style={{ fontWeight: 500 }}>{e.candidateName}</div>
                      <div style={{ color: '#bbb', fontSize: 11 }}>{e.passport}</div>
                    </td>
                    <td style={{ padding: '10px 16px', color: '#666' }}>{e.location}</td>
                    <td style={{ padding: '10px 16px' }}>
                      <span style={{ background: '#f5f5f3', padding: '2px 8px', borderRadius: 6, color: '#555' }}>{e.category}</span>
                    </td>
                    <td style={{ padding: '10px 16px', color: '#888', maxWidth: 200 }}>{e.comment || '—'}</td>
                    <td style={{ padding: '10px 16px', color: '#666' }}>{e.responsible}</td>
                    <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: 600, color: '#1a1a1a' }}>{e.amount.toLocaleString('ru-RU')} ₽</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
</>}
      </main>
    </div>
  )
}